import AccountAPI from "./AccountAPI";

const AccountApiClient = new AccountAPI();

export default AccountApiClient;